import { generateKeys, generateLocalization } from '../utils';
import { companies } from './companies';
import { clientTypes } from './client';
const dueDiligenceSteps = generateLocalization('dueDiligenceSteps', generateKeys({
    businessPlan: {
        stepPosition: 0,
        label: 'Business Plan',
        localization: { id: '', defaultMessage: '' },
    },
    experience: {
        stepPosition: 1,
        label: 'Experience',
        localization: { id: '', defaultMessage: '' },
    },
}));
const dueDiligencePromoteProducts = generateLocalization('dueDiligencePromoteProducts', generateKeys({
    websites: {
        value: 'websites',
        localization: { id: '', defaultMessage: '' },
        label: 'Website(s)',
    },
    groupsChats: {
        value: 'groups_chats',
        localization: { id: '', defaultMessage: '' },
        label: 'Telegram Group(s)',
        deprecated: true,
    },
    socialMediaAccounts: {
        value: 'social_media_accounts',
        localization: { id: '', defaultMessage: '' },
        label: 'Social media account(s) (Facebook, Instagram, Telegram, YouTube etc.)',
    },
    youtube: {
        value: 'youtube',
        localization: { id: '', defaultMessage: '' },
        label: 'Youtube',
        deprecated: true,
    },
    education: {
        value: 'education',
        localization: { id: '', defaultMessage: '' },
        label: 'Education',
    },
    seminars: {
        value: 'seminars',
        localization: { id: '', defaultMessage: '' },
        label: 'Seminars (Offline Events)',
    },
    webinars: {
        value: 'webinars',
        localization: { id: '', defaultMessage: '' },
        label: 'Webinars (Online Events)',
    },
    offline: {
        value: 'offline',
        localization: { id: '', defaultMessage: '' },
        label: 'Offline (Face to face)',
    },
    existingPortofolio: {
        value: 'existing_portofolio',
        localization: { id: '', defaultMessage: '' },
        label: 'Promotion to existing portfolio',
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
    },
    enterBriefDescription: {
        value: 'enterBriefDescription',
        localization: { id: '', defaultMessage: '' },
        label: 'Enter a brief description of your business plan',
        deprecated: true,
    },
}));
const dueDiligenceServicesOffer = generateLocalization('dueDiligenceServicesOffer', generateKeys({
    referrals: {
        value: 'referrals',
        localization: { id: '', defaultMessage: '' },
        label: 'I will refer BDSwiss as my trusted broker (Referral services)',
    },
    signals: {
        value: 'signals',
        localization: { id: '', defaultMessage: '' },
        label: 'I will provide Signals',
    },
    fundManagementServices: {
        value: 'fundManagementServices',
        localization: { id: '', defaultMessage: '' },
        label: 'I will become a Fund Manager',
    },
    education: {
        value: 'education',
        localization: { id: '', defaultMessage: '' },
        label: 'I will provide Trading  and/or Financial Education',
    },
    tradingSoftwares: {
        value: 'tradingSoftwares',
        localization: { id: '', defaultMessage: '' },
        label: 'I will provide EAs (Trading Softwares)',
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
    },
    enterBriefDescription: {
        value: 'enterBriefDescription',
        localization: { id: '', defaultMessage: '' },
        label: 'Enter a brief description of the services you will offer',
        deprecated: true,
    },
    additionalMaterialUpload: {
        value: 'additionalMaterialUpload',
        localization: { id: '', defaultMessage: '' },
        label: 'Please upload here any additional material to support your application (optional)',
        deprecated: true,
    },
}));
const existingClientsOptions = generateLocalization('existingClientsOptions', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
    },
}));
const planningOnboardOptions = generateLocalization('planningOnboardOptions', generateKeys({
    oneToHundred: {
        value: 'oneToHundred',
        localization: { id: '', defaultMessage: '' },
        label: '1 - 100',
        deprecated: true,
    },
    hundredToThousand: {
        value: 'hundredToThousand',
        localization: { id: '', defaultMessage: '' },
        label: '100 - 1000',
        deprecated: true,
    },
    moreThanThousand: {
        value: 'moreThanThousand',
        localization: { id: '', defaultMessage: '' },
        label: 'More than 1000',
        deprecated: true,
    },
    oneToFifty: {
        value: 'oneToFifty',
        localization: { id: '', defaultMessage: '' },
        label: '1 - 50',
    },
    fiftyToHundred: {
        value: 'fiftyToHundred',
        localization: { id: '', defaultMessage: '' },
        label: '50 - 100',
    },
    hundredToFiveHundred: {
        value: 'hundredToFiveHundred',
        localization: { id: '', defaultMessage: '' },
        label: '100 - 500',
    },
    moreThanFiveHundred: {
        value: 'moreThanFiveHundred',
        localization: { id: '', defaultMessage: '' },
        label: '500+',
    },
}));
const amountDepositsOptions = generateLocalization('amountDepositsOptions', generateKeys({
    zeroTo10k: {
        value: 'zeroTo10k',
        localization: { id: '', defaultMessage: '' },
        label: '0 - 10k',
    },
    tenToFifty: {
        value: 'tenToFifty',
        localization: { id: '', defaultMessage: '' },
        label: '10k - 50k',
    },
    fiftyToHundred: {
        value: 'fiftyToHundred',
        localization: { id: '', defaultMessage: '' },
        label: '50k - 100k',
    },
    moreThanHundred: {
        value: 'moreThanHundred',
        localization: { id: '', defaultMessage: '' },
        label: '100k +',
    },
}));
const onboardOtherIBsOptions = generateLocalization('onboardOtherIBsOptions', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
    },
}));
const relevantLicensesOptions = generateLocalization('relevantLicensesOptions', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
    },
}));
const dueDiligenceYearsOfExperience = generateLocalization('dueDiligenceYearsOfExperience', generateKeys({
    oneToFiveYears: {
        value: 'oneToFiveYears',
        localization: { id: '', defaultMessage: '' },
        label: '1 - 5 years',
    },
    fiveToTenYears: {
        value: 'fiveToTenYears',
        localization: { id: '', defaultMessage: '' },
        label: '5 - 10 years',
    },
    moreThanTenYears: {
        value: 'moreThanTenYears',
        localization: { id: '', defaultMessage: '' },
        label: 'More than 10 years',
    },
    noExperience: {
        value: 'noExperience',
        localization: { id: '', defaultMessage: '' },
        label: 'No Experience',
    },
}));
const dueDiligenceTermsConditions = generateLocalization('dueDiligenceTermsCondtions', generateKeys({
    agreedTerms1: {
        value: 'agreedTerms1',
        localization: { id: '', defaultMessage: '' },
        label: 'You have not been engaged in or have benefited from criminal conduct in any part of the world.',
    },
    agreedTerms2: {
        value: 'agreedTerms2',
        onlyText: true,
        localization: { id: '', defaultMessage: '' },
        label: 'The information given herein and the requested documents herby attached are to the best of your knowledge true and accurate as at the date hereof, and should there be any changes in the information provided you undertake to promptly advise our company of the same in writing.',
    },
}));
const dueDiligenceDescriptionObject = {
    promoteProducts: {
        value: 'promoteProducts',
        label: 'Please note that all online promotion channels should have a visible Risk Warning disclaimer when promoting our Company.',
        localization: { id: '', defaultMessage: '' },
        isTooltipOnly: false,
    },
    servicesOffer: {
        value: 'servicesOffer',
        label: 'Please use this section to provide us with samples (screenshots of websites/social media accounts, sample of trading groups posts, any presentations, slides etc)',
        localization: { id: '', defaultMessage: '' },
        isTooltipOnly: true,
    },
};
const dueDiligenceDesription = generateLocalization('dueDiligenceDesription', generateKeys(dueDiligenceDescriptionObject));
export const dueDiligenceQuestions = generateLocalization('DueDiligence', generateKeys({
    yearsOfExperience: {
        value: 'yearsOfExperience',
        localization: { id: '', defaultMessage: '' },
        order: 1,
        orderLabel: 1,
        label: 'Do you have experience as a Partner? If yes, with which company?',
        question: 'yearsOfExperienceQuestion',
        options: dueDiligenceYearsOfExperience,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
        radioBtn: true,
    },
    companyName: {
        value: 'companyName',
        localization: { id: '', defaultMessage: '' },
        order: 2,
        orderLabel: 1.1,
        label: 'Company name:',
        question: 'companyNameQuestion',
        mandatory: (answers, field = 'value') => {
            const promoteProductsA = dueDiligenceYearsOfExperience.oneToFiveYears;
            const promoteProductsB = dueDiligenceYearsOfExperience.fiveToTenYears;
            const promoteProductsC = dueDiligenceYearsOfExperience.moreThanTenYears;
            return (answers.yearsOfExperience.includes(promoteProductsA[field]) ||
                answers.yearsOfExperience.includes(promoteProductsB[field]) ||
                answers.yearsOfExperience.includes(promoteProductsC[field]));
        },
        relevant: (answers, field = 'value') => {
            const promoteProductsA = dueDiligenceYearsOfExperience.oneToFiveYears;
            const promoteProductsB = dueDiligenceYearsOfExperience.fiveToTenYears;
            const promoteProductsC = dueDiligenceYearsOfExperience.moreThanTenYears;
            return (answers.yearsOfExperience.includes(promoteProductsA[field]) ||
                answers.yearsOfExperience.includes(promoteProductsB[field]) ||
                answers.yearsOfExperience.includes(promoteProductsC[field]));
        },
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        textfield: true,
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
    },
    promoteProducts: {
        value: 'promoteProducts',
        localization: { id: '', defaultMessage: '' },
        order: 3,
        orderLabel: 2,
        label: 'How will you promote our Company?',
        description: dueDiligenceDesription.promoteProducts,
        question: 'promoteProductsQuestion',
        options: dueDiligencePromoteProducts,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        multiselect: true,
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
    },
    promoteProductsLinks: {
        value: 'promoteProductsLinks',
        localization: { id: '', defaultMessage: '' },
        order: 4,
        orderLabel: 2.1,
        label: 'Enter Links',
        question: 'promoteProductsLinksQuestion',
        mandatory: (answers, field = 'value') => {
            const promoteProductsA = dueDiligencePromoteProducts.websites;
            const promoteProductsB = dueDiligencePromoteProducts.socialMediaAccounts;
            return (answers.promoteProducts.includes(promoteProductsA[field]) ||
                answers.promoteProducts.includes(promoteProductsB[field]));
        },
        relevant: (answers, field = 'value') => {
            const promoteProductsA = dueDiligencePromoteProducts.websites;
            const promoteProductsB = dueDiligencePromoteProducts.socialMediaAccounts;
            return (answers.promoteProducts.includes(promoteProductsA[field]) ||
                answers.promoteProducts.includes(promoteProductsB[field]));
        },
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        textfield: true,
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
    },
    promoteProductsDescription: {
        value: 'promoteProductsDescription',
        localization: { id: '', defaultMessage: '' },
        order: 5,
        orderLabel: 2.2,
        label: 'Enter a brief description of your business plan (optional)',
        question: 'promoteProductsDescriptionQuestion',
        mandatory: () => false,
        relevant: (answers, field = 'value') => {
            const promoteProductsF = dueDiligencePromoteProducts.other;
            return (answers.promoteProducts.includes(promoteProductsF[field]));
        },
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        textfield: true,
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
    },
    promoteProductsBusinessPlan: {
        value: 'promoteProductsBusinessPlan',
        localization: { id: '', defaultMessage: '' },
        order: 6,
        orderLabel: 2.3,
        label: 'Describe your business plan',
        question: 'promoteProductsBusinessPlanQuestion',
        mandatory: (answers, field = 'value') => {
            const promoteProductsF = dueDiligencePromoteProducts.other;
            return (answers.promoteProducts.includes(promoteProductsF[field]));
        },
        relevant: (answers, field = 'value') => {
            const promoteProductsF = dueDiligencePromoteProducts.other;
            return (answers.promoteProducts.includes(promoteProductsF[field]));
        },
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        textfield: true,
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
        deprecated: true,
    },
    servicesOffer: {
        value: 'servicesOffer',
        localization: { id: '', defaultMessage: '' },
        order: 7,
        orderLabel: 3,
        label: 'What services will you offer to clients?',
        question: 'servicesOfferQuestion',
        options: dueDiligenceServicesOffer,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        multiselect: true,
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
    },
    servicesOfferDescription: {
        value: 'servicesOfferDescription',
        localization: { id: '', defaultMessage: '' },
        order: 8,
        orderLabel: 3.1,
        label: 'Enter a brief description of the services you will offer (optional)',
        question: 'servicesOfferDescriptionQuestion',
        mandatory: () => false,
        relevant: (answers, field = 'value') => {
            const servicesOfferB = dueDiligenceServicesOffer.other;
            return answers.servicesOffer.includes(servicesOfferB[field]);
        },
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        textfield: true,
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
    },
    planningOnboard: {
        value: 'planningOnboard',
        localization: { id: '', defaultMessage: '' },
        order: 10,
        orderLabel: 4,
        label: 'How many Clients are you planning to refer?',
        question: 'planningOnboardQuestion',
        mandatory: () => true,
        relevant: () => true,
        options: planningOnboardOptions,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
        radioBtn: true,
    },
    amountDeposits: {
        value: 'amountDeposits',
        localization: { id: '', defaultMessage: '' },
        order: 11,
        orderLabel: 5,
        label: 'What amount of deposits are you expecting?',
        question: 'amountDepositsQuestion',
        mandatory: () => true,
        relevant: () => true,
        options: amountDepositsOptions,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
        radioBtn: true,
    },
    onboardOtherIBs: {
        value: 'onboardOtherIBs',
        localization: { id: '', defaultMessage: '' },
        order: 12,
        orderLabel: 6,
        label: 'Are you planning to refer other Partners as well?',
        question: 'onboardOtherIBsQuestion',
        mandatory: () => true,
        relevant: () => true,
        options: onboardOtherIBsOptions,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
        radioBtn: true,
    },
    existingClients: {
        value: 'existingClients',
        localization: { id: '', defaultMessage: '' },
        order: 8,
        orderLabel: 3,
        label: 'Do you have an existing clients portfolio?',
        question: 'existingClientsQuestion',
        mandatory: () => true,
        relevant: () => true,
        options: existingClientsOptions,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
        radioBtn: true,
        deprecated: true,
    },
    relevantLicenses: {
        value: 'relevantLicenses',
        localization: { id: '', defaultMessage: '' },
        order: 10,
        orderLabel: 5,
        label: 'Do you possess a relevant license or certification from a competent regulatory authority, or a professional body, for the exercise of a specific business activity related to the provision of financial services? (please note it is not mandatory to possess one)',
        question: 'relevantLicensesQuestion',
        mandatory: () => true,
        relevant: () => true,
        options: relevantLicensesOptions,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
        radioBtn: true,
        deprecated: true,
    },
    relevantLicensesDescription: {
        value: 'relevantLicensesDescription',
        localization: { id: '', defaultMessage: '' },
        order: 11,
        orderLabel: 5.1,
        label: 'Description',
        question: 'relevantLicensesDescriptionQuestion',
        mandatory: () => false,
        relevant: () => false,
        options: existingClientsOptions,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        textfield: true,
        step: dueDiligenceSteps.businessPlan,
    },
    relevantLicensesUpload: {
        value: 'relevantLicensesUpload',
        localization: { id: '', defaultMessage: '' },
        order: 12,
        orderLabel: 5.2,
        label: 'Attach a copy of the license',
        question: 'relevantLicensesUploadQuestion',
        mandatory: () => false,
        relevant: () => false,
        options: existingClientsOptions,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        uploadBtn: true,
        uploadType: 'businessLicense',
        step: dueDiligenceSteps.businessPlan,
    },
    servicesOfferUpload: {
        value: 'servicesOfferUpload',
        localization: { id: '', defaultMessage: '' },
        order: 13,
        orderLabel: 7,
        label: 'Please upload here any additional material to support your application (optional)',
        question: 'servicesOfferUploadQuestion',
        description: dueDiligenceDesription.servicesOffer,
        mandatory: () => false,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        uploadBtn: true,
        uploadType: 'promotionalMaterial',
        step: dueDiligenceSteps.businessPlan,
    },
    termsConditions: {
        value: 'termsConditions',
        localization: { id: '', defaultMessage: '' },
        order: 14,
        orderLabel: 8,
        label: 'By Completing this form you confirm and declare that:',
        question: 'termsConditionsQuestion',
        options: dueDiligenceTermsConditions,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissComoros, companies.bdSwissSouthAfrica],
        multiselect: true,
        clientType: [clientTypes.ib, clientTypes.ibCorporate],
        step: dueDiligenceSteps.businessPlan,
    },
}));
const dueDiligenceStatuses = generateKeys({
    underReview: {
        value: 'under_review',
        label: 'Under Review',
    },
    approved: {
        value: 'approved',
        label: 'Approved',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
    pending: {
        value: 'pending',
        label: 'Pending',
    },
});
export { dueDiligencePromoteProducts, dueDiligenceServicesOffer, existingClientsOptions, dueDiligenceYearsOfExperience, dueDiligenceStatuses, dueDiligenceSteps, relevantLicensesOptions, dueDiligenceTermsConditions, dueDiligenceDesription, planningOnboardOptions, onboardOtherIBsOptions, amountDepositsOptions, };
